import styled from "styled-components";
import HeroLandingPage from "../../assets/icons/hero-landingPage.png";
import { colors } from "../../theme/color";
import fipayFonts from "../../theme/index";
import PhoneInput from "react-phone-number-input";

export const SignUpContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  padding: 20px;
  gap: 30px;
  justify-content: center;
`;

export const SectionOne = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeroBackgroundImage = styled.div`
  width: 100%;
  height: 100%;
  background-image: url("/assets/icons/hero-landingPage.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  img {
    width: 100%;
    height: 100vh;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
`;
export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background-image: url("/assets/icons/hero-landingPage.png");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
`;

export const HeaderContainer = styled.div`
  position: absolute;
  top: 3%;
  left: 10%;

  img {
    //width: 100%;
    height: auto;
    cursor: pointer;

    @media screen and (max-width: 768px) {
      width: 60%;
    }
    @media screen and (max-width: 375px) {
      width: 50%;
      top: 0%;
      //  border: 2px solid red;
    }
  }
`;

export const BackContainer = styled.div`
  position: absolute;
  top: 15%;
  left: 10%;
  display: flex;
  align-items: center;
  @media screen and (max-width: 768px) {
    top: 9%;
    left: 6%;
  }
  @media screen and (max-width: 375px) {
    top: 7%;
    left: 6%;
    img {
      width: 25%;
    }
  }
  @media screen and (max-width: 280px) {
    top: 7%;
  }
`;

export const NestedModalContainer = styled.div`
  // position: absolute;
  // top: 52%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  background-color: white;
  padding: 40px 20px 40px 10px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 65%;
  // height: 530px; /* Set a maximum height */
  overflow-y: auto; /* Enable vertical scrolling */
  margin-top: 140px;

  @media screen and (max-width: 1280px) and (max-height: 800px) {
    width: 80%;
    height: 72%;
    padding: 20px;
  }

  @media screen and (max-width: 1024px) and (max-height: 1366px) {
    width: 80%;
    height: 50%;
    padding: 20px;
  }

  @media screen and (max-width: 1024px) and (max-height: 912px) {
    width: 80%;
    height: 550px;
    padding: 20px;
  }

  @media screen and (max-width: 1024px) and (max-height: 898px) {
    width: 80%;
    height: 70%;
    padding: 20px;
  }

  @media screen and (max-width: 1024px) and (max-height: 600px) {
    width: 80%;
    height: 430px;
    padding: 20px;
  }

  @media screen and (max-width: 912px) and (max-height: 1368px) {
    width: 80%;
    height: 640px;
    padding: 20px;
  }

  @media screen and (max-width: 820px) {
    width: 80%;
    height: 640px;
    padding: 20px;
  }

  @media screen and (max-width: 768px) {
    width: 80%;
    height: 690px;
    padding: 20px;
  }

  @media screen and (max-width: 540px) {
    width: 80%;
    padding: 10px;
    margin-top: 40px;
  }

  @media screen and (max-width: 480px) {
    width: 80%;
    padding: 12px;
    margin-top: 50px;
  }

  @media screen and (max-width: 414px) {
    width: 80%;
    padding: 12px;
    margin-top: 50px;
  }

  @media screen and (max-width: 390px) {
    width: 80%;
    padding: 10px;
  }

  @media screen and (max-width: 375px) {
    width: 80%;
    padding: 10px;
    margin-top: 30px;
  }

  @media screen and (max-width: 280px) {
    width: 80%;
    padding: 5px;
  }
  padding-inline: 25px;
  height: auto !important;
`;

export const SignUpTextContainer = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 412px) and (max-height: 915px) {
    width: 100%;
    margin-top: 20px;
  }

  @media screen and (max-width: 820px) {
    width: 100%;
    margin: 0 auto;
  }

  // @media screen and (max-width: 430px) and (max-height: 932px) {
  //   margin-top: 40px;
  // }

  @media screen and (max-width: 375px) and (max-height: 667px) {
    margin-bottom: 0px;
  }
`;

export const AccountInformation = styled.div`
  max-width: 500px;
  text-align: center;
  font-size: ${fipayFonts.fipayFonts.fontSize.heading2};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  color: ${colors.NAVYBLUE};
  font-family: "Gt Walsheim Pro", sans-serif;

  @media screen and (max-width: 1024px) and (max-height: 1366px) {
    text-align: center;
    margin: 0 auto;
  }

  @media screen and (max-width: 912px) and (max-height: 1368px) {
    text-align: center;
    margin: 0 auto;
  }

  @media screen and (max-width: 820px) {
    text-align: center;
    margin: 0 auto;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    font-family: GT Walsheim Pro;
    font-size: ${fipayFonts.fipayFonts.fontSize.body1};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: center;
    // margin-left:10px;
  }

  @media screen and (max-width: 375px) {
    font-family: GT Walsheim Pro;
    font-size: ${fipayFonts.fipayFonts.fontSize.body1};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: center;
  }
`;

export const CreateAccountText = styled.div`
  text-align: center;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  margin-top: 15px;
  color: ${colors.DARK_GRAY};
  font-family: "Gt Walsheim Pro", sans-serif;

  @media screen and (max-width: 768px) and (max-height: 1024px) {
    width: 100%;
    text-align: center;
  }

  @media screen and (max-width: 412px) and (max-height: 915px) {
    width: 70%;
    text-align: center;
    margin-top: 15px;
    margin-left: 50px;
    margin-bottom: 15px;
    letter-spacing: 0.5px;
  }
`;

export const FirstInputContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
  @media screen and (max-width: 430px) {
    margin-top: 30px;
  }
  @media screen and (max-width: 375px) {
    margin-top: 10px;
    padding-top: 0px;
  }
`;

export const SecondInputContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ThirdInputContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 5px;
  @media screen and (max-width: 1024px) and (max-height: 600px) {
    padding-top: 20px;
  }
  @media screen and (max-width: 820px) {
    padding-top: 35px;
  }
  @media screen and (max-width: 540px) {
    padding-top: 0px;
  }

  @media screen and (max-width: 430px) and (max-height: 932px) {
    width: 100%;
    text-align: center;
    margin-top: 15px;
  }

  // @media screen and (max-width: 412px) and (max-height: 915px) {
  //   width: 100%;
  //   text-align: center;
  //   margin-top: 30px;
  // }
  @media screen and (max-width: 390px) {
    width: 100%;
    text-align: center;
    margin-top: 8px;
  }
  @media screen and (max-width: 375px) {
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }
  @media screen and (max-width: 360px) {
    width: 100%;
    text-align: center;
    margin-top: 15px;
  }
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  // gap: 3px;
  padding-left: 15px;
  @media screen and (max-width: 768px) {
    display: none;
  }
  @media screen and (max-width: 1024px) and (max-height: 600px) {
    display: none;
  }

  @media screen and (max-width: 820px) {
    width: 100%;
  }

  @media screen and (max-width: 412px) and (max-height: 915px) {
    width: 100%;
    text-align: center;
    margin-top: 40px;
  }

  @media screen and (max-width: 390px) and (max-height: 844px) {
    width: 100%;
    text-align: center;
    margin-top: 15px;
  }

  @media screen and (max-width: 360px) and (max-height: 740px) {
    width: 100%;
    text-align: center;
    margin-top: 15px;
  }
`;

export const AtLeastText = styled.span`
  font-family: "Gt Walsheim Pro", sans-serif;
  font-size: ${fipayFonts.fipayFonts.fontSize.footer1};
  font-style: normal;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
`;

export const Requirement = styled.div`
  width: 35%;
  display: flex;
  justify-content: space-between;
  padding-top: 5px;
  font-size: ${fipayFonts.fipayFonts.fontSize.footer1};
  @media screen and (max-width: 1024px) {
    width: 50%;
  }
  @media screen and (max-width: 820px) {
    width: 50%;
  }
`;

export const RequirementText = styled.span<{ $active?: boolean }>`
  font-family: "Gt Walsheim Pro", sans-serif;
  font-size: ${fipayFonts.fipayFonts.fontSize.footer1};
  font-style: normal;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  border: 2px dotted
    ${({ $active }) => ($active ? colors.success.emerald : colors.NEUTRAL_GREY)};
  padding: 3px;
  border-radius: 10px;
  color: ${({ $active }) =>
    $active ? colors.success.emerald : colors.NEUTRAL_GREY};
`;

export const SpecialRequirement = styled.div`
  width: 20%;
  display: flex;
  padding-top: 5px;
  justify-content: space-between;
  @media screen and (max-width: 1024px) {
    width: 29%;
  }
  @media screen and (max-width: 820px) {
    width: 29%;
  }
`;

export const SpecialRequirementText = styled.span`
  font-family: "Gt Walsheim Pro", sans-serif;
  font-size: ${fipayFonts.fipayFonts.fontSize.footer1};
  font-style: normal;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  border: 2px dotted #e8eaed;
  padding: 3px;
  border-radius: 10px;
  line-height: normal;
  color: #8c8b8b;
`;

export const SpecialRequirementTextNum = styled.span`
  font-family: "Gt Walsheim Pro", sans-serif;
  font-size: ${fipayFonts.fipayFonts.fontSize.footer1};
  font-style: normal;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  padding-left: 55px;
  border: 2px dotted #e8eaed;
  padding: 3px;
  border-radius: 10px;
  line-height: normal;
  color: #8c8b8b;
`;

export const GoBackText = styled.span`
  font-family: GT Walsheim Pro;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-style: normal;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  cursor: pointer;
  color: #09005b;
  margin-left: 2px;
  @media screen and (max-width: 768px) {
  }
  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  }
`;

export const PhoneContainer = styled.div`
  display: flex;
  align-items: center;
`;
export const SmallInput = styled.input`
  height: 30px;
  text-indent: 10px;
  padding: 8px;
  width: 10%;
  border: 1px solid #f0f2f4;
  border-radius: 15px;
  margin-left: 15px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  position: relative;
  color: #0e0e0e;
  font-family: "Gt Walsheim Pro", sans-serif;

  &:focus {
    outline: none;
    border-color: #322b76;
    background-color: #e9eaf9;
  }

  @media screen and (max-width: 375px) {
    height: 10px;
    padding: 5px;
    font-size: ${fipayFonts.fipayFonts.fontSize.footer1};
  }
`;

export const LargeInput = styled(PhoneInput)`
  height: 30px;
  text-indent: 10px;
  padding: 8px;
  margin-left: 8px;
  width: 93%;
  border: 1px solid #f0f2f4;
  border-radius: 15px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  position: relative;
  color: #0e0e0e;
  font-family: "Gt Walsheim Pro", sans-serif;

  -moz-appearance: textfield;

  &:focus {
    outline: none;
    border-color: #322b76;
    background-color: #e9eaf9;
  }

  @media screen and (max-width: 375px) {
    height: 20px;
    padding: 5px;
    font-size: ${fipayFonts.fipayFonts.fontSize.footer1};
  }
`;

export const PhoneBox = styled.div``;

export const Label = styled.label`
  display: block;
  margin-bottom: 20px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  font-family: "Gt Walsheim Pro", sans-serif;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  margin-top: 20px;
  margin-left: 15px;
`;
